import ReactQuill from "react-quill";
import "./QuillEditor.style.scss";

export interface IQuillEditorProps {
  content: string;
  onChange: (value: string) => void;
}

export default function QuillEditor(props: IQuillEditorProps) {
  const modules = {
    toolbar: [
      // [{ font: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ font: [] }, { size: ["14px", "16px", "18px"] }],
      // [{ size: ["14px", "16px", "18px"] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }],
      [{ script: "sub" }, { script: "super" }],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }, { align: [] }],
      ["link", "image", "video"],
      ["clean"],
    ],
  };

  return (
    <ReactQuill
      theme="snow"
      className="quill-editor"
      modules={modules}
      onChange={props.onChange}
      value={props.content}
    />
  );
}
